import {audioRecorder1, audioRecorder2, coolgpt1, coolgpt2, dataTable1, dataTable2, ecommerce1, ecommerce2, faceDetector1, faceDetector2, projectHero1, projectHero2, puzzle1, puzzle2, quizapp1, quizapp2, resumebuilder1, resumebuilder2, social1, social2, todo1, todo2, weather1, weather2, youtube1, youtube2} from '../../assets'

export const projectData= [
    {
        image1: projectHero1,
        image2: projectHero2,
        title: 'Project Hero',
        description: "A contractor based website with powerful query search and personalized user profiles.",
        tech: "Nextjs, Reactjs, Material Ui,  HTML, CSS, Typescript",
        github: 'https://github.com/saransh79/ProjectHero',
        demo: 'https://project-hero-gamma.vercel.app/'
    },
    {
        image1: faceDetector1,
        image2: faceDetector2,
        title: "Face Authenticator",
        description: "A platform powered by Face-api.js, enabling users to authenticate using facial recognition.",
        tech: "Face-api.js, Reactjs, NodeJs, Express, MongoDB, Material UI, HTML, CSS, Javascript",
        github: "https://github.com/saransh79/Face-Detector",
        demo: 'https://face-detector-one.vercel.app/'
    },
    {
        image1: youtube1,
        image2: youtube2,
        title: 'Youtube Clone',
        description: "A YouTube clone powered by the YouTube v3 API, delivering a replicated video-surfing experience with modern features.",
        tech: "Reactjs, Material Ui, Youtube V3 API, HTML, CSS, Javascript",
        github: 'https://github.com/saransh79/Youtube-Clone',
        demo: 'https://youtube-clone-six-lac.vercel.app/'
    },
    {
        image1: social1,
        image2: social2,
        title: 'Social Media Website',
        description: "A dynamic social platform enabling users to connect, share posts, and build friendships.",
        tech: "MongoDB, Express, React, Node, bcrypt, jwt, formik, multer, Material UI",
        github: 'https://github.com/saransh79/social-media-website',
        demo: 'https://social-media-website-sand.vercel.app/'
    },
    {
        image1: resumebuilder1,
        image2: resumebuilder2,
        title: 'Resume Builder',
        description: "React-based resume builder for effortless and customizable resume creation.",
        tech: "React, Modular CSS, HTML, Javascript",
        github: 'https://github.com/saransh79/Resume-builder',
        demo: 'https://resume-hack.netlify.app/'
    },
    {
        image1: coolgpt1,
        image2: coolgpt2,
        title: 'CoolGPT',
        description: "ChatGPT-style website handling both text and image tasks effortlessly.",
        tech: "React, Material Ui, OpenAI Api, Javascript",
        github: 'https://github.com/saransh79/CoolGPT-frontend',
        demo: 'https://cool-gpt-u5k1.vercel.app/'
    },
    {
        image1: weather1,
        image2: weather2,
        description: "A user-friendly weather website allowing easy search by city or location.",
        tech: "React, Typescript, Redux, formik, Tailwind CSS",
        title: "Weather App",
        github: "https://github.com/saransh79/Weather",
        demo: "https://weather-saransh79.vercel.app/"
    },
    {
        image1: ecommerce1,
        image2: ecommerce2,
        description: "A static shopping website of clothes with stunning UI",
        title: 'Ecommerce Website',
        tech: "HTML, CSS, Javascript",
        github: 'https://github.com/saransh79/SARA-Ecommerce-Website',
        demo: 'https://saransh79.github.io/SARA-Ecommerce-Website/'
    },
    {
        image1: todo1,
        image2: todo2,
        title: 'MERN Todo App',
        description: "Easy-to-use website with user authentication to help you manage your tasks and to-dos.",
        tech: "MongoDB, Express, React, Node, Redux, HTML, CSS, Javascript",
        github: 'https://github.com/saransh79/todo-frontend',
        demo: 'https://mern-todolist-app.netlify.app'
    },

    {
        image1: quizapp1,
        image2: quizapp2,
        title: 'Mathematics Quiz App',
        description: "Fun mathematics quiz app to challenge and enhance your math skills.",
        tech: "React, Typescript, Open Trivia Api, Modular CSS, HTML",
        github: 'https://github.com/saransh79/Quiz-App',
        demo: 'https://mathematics-quiz-app.netlify.app/'
    },
    {
        image1: puzzle1,
        image2: puzzle2,
        title: 'Puzzle Website',
        description: "A puzzle website with a leaderboard for friendly competition and skill comparison.",
        tech: "MongoDB, Express, React, Node, Material Ui, JWT, axios",
        github: 'https://github.com/saransh79/puzzle-frontend',
        demo: 'https://puzzle-website.netlify.app/'
    },
    {
        image1: dataTable1,
        image2: dataTable2,
        title: 'Data Table',
        description: "A data management website for admin to quickly filter and manage data.",
        tech: "React, Material Ui, Material-React-Table",
        github: 'https://github.com/saransh79/Data-Table',
        demo: 'https://data-table-ebon.vercel.app/'
    },
    {
        image1: audioRecorder1,
        image2: audioRecorder2,
        title: 'Audio Recorder',
        description: "A website to quickly record and play audios.",
        tech: "React, HTML, CSS, Javascript",
        github: 'https://github.com/saransh79/Audio-Recorder',
        demo: 'https://audio-recorder-two.vercel.app/'
    },
]